import { render, staticRenderFns } from "./Subheader.vue?vue&type=template&id=4ca5db12&"
import script from "./Subheader.vue?vue&type=script&lang=ts&"
export * from "./Subheader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports